import React from "react";
import {Card} from "react-bootstrap"
import { formatDate } from "../../../../../../util/Helpers";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";

const NewsList = ({news}) => {

    return news.map((el, i) => {

        return <div className="card mb-3" key={`news-${i}`}>
                    <a  
                        href={el.url} 
                        target="_blank"
                        className="text-dark"
                        rel="noopener noreferrer" 
                    >
                        <Card.Body className="col ">
                            <Card.Img variant="top" src={el.imageUrl ?? toAbsoluteUrl("/media/stock-600x400/img-60.jpg")} />
                            <Card.Title className="my-4"> {el.title}</Card.Title>
                            <Card.Text>
                                {el.content?.substr(0, 150)}...
                            </Card.Text>
                            <small className="text-muted">{formatDate(el.date)}</small>
                        </Card.Body>
                    </a>
                </div>
    });
}

export default NewsList;